import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { API_BASE_URL, authHeaders, getSession } from "./apiConfig";

// Wrap any route with <ProtectedRoute screenKey="party-master">...</ProtectedRoute>
// - Not logged in -> redirect to /login
// - Logged in but role has no View right on this screen -> show Access Denied
// - Logged in and allowed -> render the page normally
const ProtectedRoute = ({ screenKey, children }) => {
  const session = getSession();
  const [status, setStatus] = useState("checking"); // checking | allowed | denied

  useEffect(() => {
    if (!session?.token) return; // handled by redirect below

    if (!screenKey) {
      setStatus("allowed"); // no specific screen to check — just needs to be logged in
      return;
    }

    fetch(`${API_BASE_URL}/permission/my`, { headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : []))
      .then((rows) => {
        const row = rows.find((r) => r.screenKey === screenKey);
        setStatus(row?.canView ? "allowed" : "denied");
      })
      .catch(() => setStatus("denied"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenKey]);

  if (!session?.token) {
    return <Navigate to="/login" replace />;
  }

  if (status === "checking") {
    return (
      <div style={{ padding: "4rem", textAlign: "center", color: "#64748b" }}>
        Checking access...
      </div>
    );
  }

  if (status === "denied") {
    return (
      <div style={{ padding: "4rem", textAlign: "center" }}>
        <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🔒</div>
        <h2 style={{ color: "#0f172a", marginBottom: "0.5rem" }}>Access Denied</h2>
        <p style={{ color: "#64748b" }}>
          Your role ({session.Role}) doesn't have permission to view this page.
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;